module.exports = __webpack_public_path__ + "img/medaillonsondages.bc136caf.png";